export enum SearchTypeEnum {
  NATIONAL_ID = 'nationalId',
  PASSPORT_NO = 'passportNo',
  REGISTRATION_NO = 'registrationNo'
}
